import React from 'react';
import {
  WAYGPT_AI_CHIP_URL,
  WAYGPT_AI_ICON_URL,
  WAYGPT_AI_URL,
} from '../../utils/platformAssets';

/**
 * Каноническая иконка AI / ВЭЙГПТ / ассистента.
 * API совместим с Lucide (`size`) — можно подставлять в SIDEBAR_ICONS.robot и Avatar.
 *
 * fit="circle" — аватар на полный круг без квадратных углов и без обрезки персонажа
 * (icon + contain ~90% внутри круга, мягкий фон заполняет дуги).
 * Для крупных empty states: fit="circle" + variant="full".
 *
 * @param {'chip'|'icon'|'full'} [variant='icon']
 * @param {'default'|'circle'} [fit='default']
 */
const SRC = {
  chip: WAYGPT_AI_CHIP_URL,
  icon: WAYGPT_AI_ICON_URL,
  full: WAYGPT_AI_URL,
};

/** Для круга по умолчанию — icon (прозрачный фон, без тёмной рамки chip). */
const CIRCLE_SRC_VARIANT = 'icon';

export default function WayGptIcon({
  size = 20,
  variant = 'icon',
  fit = 'default',
  className = '',
  alt = 'WayGPT AI',
  style,
  ...rest
}) {
  const px = typeof size === 'number' ? size : Number(size) || 20;
  const srcVariant =
    fit === 'circle'
      ? (variant === 'full' ? 'full' : CIRCLE_SRC_VARIANT)
      : variant;
  const src = SRC[srcVariant] || SRC.icon;
  const baseClass = `mb-waygpt-icon ${fit === 'circle' ? 'mb-waygpt-icon--circle' : ''} ${className}`.trim();

  if (fit === 'circle') {
    return (
      <span
        className={baseClass}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: px,
          height: px,
          borderRadius: '50%',
          overflow: 'hidden',
          flexShrink: 0,
          verticalAlign: 'middle',
          background:
            'linear-gradient(155deg, var(--info-bg, #eef5ff) 0%, var(--brand-soft, #d4e4ff) 48%, var(--info-border, #b7d0f8) 100%)',
          boxShadow: 'inset 0 0 0 1px color-mix(in srgb, var(--info, #2563eb) 14%, transparent)',
          lineHeight: 0,
          ...style,
        }}
        role={alt ? 'img' : undefined}
        aria-label={alt || undefined}
        aria-hidden={alt ? undefined : true}
        {...rest}
      >
        <img
          src={src}
          alt=""
          width={px}
          height={px}
          decoding="async"
          draggable={false}
          style={{
            display: 'block',
            width: '98%',
            height: '98%',
            objectFit: 'contain',
            objectPosition: 'center 42%',
            pointerEvents: 'none',
            userSelect: 'none',
          }}
        />
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      width={px}
      height={px}
      decoding="async"
      draggable={false}
      className={baseClass}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        objectFit: 'contain',
        flexShrink: 0,
        ...style,
      }}
      {...rest}
    />
  );
}
